import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography, Button } from '@metarouter-private/mr-mui';
import { useRemoveSampleEvent } from '@ion/api';

export default function ConfirmDeleteView({ sampleEvent, onCancel, onDeleteSuccess }) {
  const [removeSampleEvent, { loading }] = useRemoveSampleEvent();

  const handleDelete = useCallback(async () => {
    const response = await removeSampleEvent({ id: sampleEvent.id });
    if (!response.errors) {
      onDeleteSuccess();
    }
  }, [removeSampleEvent, sampleEvent, onDeleteSuccess]);

  return (
    <Stack spacing={3}>
      <Typography variant="h6">Delete {sampleEvent.name}?</Typography>
      <Typography color="text.secondary">
        Are you sure you want to delete this sample event? This action cannot be undone.
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button variant="outlined" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
          Delete
        </Button>
      </Stack>
    </Stack>
  );
}

ConfirmDeleteView.propTypes = {
  sampleEvent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onCancel: PropTypes.func.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
};
